const holidaysSettings = {
  workingHoursInDay: 8,
  minLimitHolidayHours: 1,
  maxLimitHolidayHours: 7,
};

export default holidaysSettings;
